import { HttpMethod } from '../../http-method'

export const deleteQueuedNotificationRequest = (uuid: string, dryRun: boolean) => ({
  method: HttpMethod.DELETE,
  url: `modules/crm/notification-queue/${uuid}`,
  params: {
    DryRun: dryRun
  }
})
